/* eslint-disable */
import * as util from "@/api/dashboard";

const state = {
    dataSentMessagesAnnually: {
        "data": [
            {
                "y": "Jan",
                "success": 0,
                "error": 0,
                "pending": 0
            },
            {
                "y": "Feb ",
                "success": 0,
                "error": 0,
                "pending": 0
            },
            {
                "y": "Mar ",
                "success": 0,
                "error": 0,
                "pending": 0
            },
            {
                "y": "Apr ",
                "success": 0,
                "error": 0,
                "pending": 0
            },
            {
                "y": "May ",
                "success": 0,
                "error": 0,
                "pending": 0
            },
            {
                "y": "Jun ",
                "success": 0,
                "error": 0,
                "pending": 0
            },
            {
                "y": "Jul ",
                "success": 0,
                "error": 0,
                "pending": 0
            },
            {
                "y": "Aug ",
                "success": 0,
                "error": 0,
                "pending": 0
            },
            {
                "y": "Sep ",
                "success": 0,
                "error": 0,
                "pending": 0
            },
            {
                "y": "Oct ",
                "success": 0,
                "error": 0,
                "pending": 0
            },
            {
                "y": "Nov ",
                "success": 0,
                "error": 0,
                "pending": 0
            },
            {
                "y": "Dec ",
                "success": 0,
                "error": 0,
                "pending": 0
            }
        ],
        "ykeys": [
            "success",
            "error",
            "pending"
        ],
        "labels": [
            "Success",
            "Error",
            "Pending"
        ],
        "colors": [
            "#55CD62",
            "#fc6075",
            "#D3DCE2"
        ]
    },
    isLoadItems: false,
    filterLoadItems: {
        brand_id: "",
        product_id: "",
        start_date: "",
        end_date: ""
    }
};


const mutations = {
    SET_dataSentMessagesAnnually: (state, value) => {
        state.dataSentMessagesAnnually = value
    },
    SET_filterLoadItems: (state, value) => {
        state.filterLoadItems = value
    },
    SET_isLoadItems: (state, value) => {
        state.isLoadItems = value
    },
};

const actions = {
    actFilterLoadItems({ commit }, data) {
        commit("SET_filterLoadItems", data);
    },
    setIsLoadItems({ commit }, data) {
        commit("SET_isLoadItems", data);
    },
    sentMessagesAnnually({ commit }, dataParams) {
        // console.log(dataParams)
        return new Promise((resolve, reject) => {
            util.sentMessagesAnnually(dataParams).then(response => {
                const { data } = response;
                commit('SET_dataSentMessagesAnnually', data)
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    getTotalScrapeMP({commit}, dataParams) {
        return new Promise((resolve, reject) => {
            util.getTotalScrapeMP(dataParams)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    getTotalScrapeStatus({commit}, dataParams) {
        return new Promise((resolve, reject) => {
            util.getTotalScrapeStatus(dataParams)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    totalStatusPerMP({commit}, dataParams) {
        return new Promise((resolve, reject) => {
            util.totalStatusPerMP(dataParams)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    totalKeywords({commit}, dataParams) {
        return new Promise((resolve, reject) => {
            util.totalKeywords(dataParams)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    totalStatusShopee({commit}, dataParams) {
        return new Promise((resolve, reject) => {
            util.totalStatusShopee(dataParams)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    totalStatusTokopedia({commit}, dataParams) {
        return new Promise((resolve, reject) => {
            util.totalStatusTokopedia(dataParams)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    totalStatusLazada({commit}, dataParams) {
        return new Promise((resolve, reject) => {
            util.totalStatusLazada(dataParams)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    totalStatusBukalapak({commit}, dataParams) {
        return new Promise((resolve, reject) => {
            util.totalStatusBukalapak(dataParams)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
};


export default {
    namespaced: true,
    state,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/store/modules/dashboard.js